import React from "react";
import {useEffect} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import BoltIcon from "@mui/icons-material/Bolt";
import { alpha, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useAuth } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/logo.png";

const ClintMainPage = () => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	const quickActions = [
		{
			title: "طلب جديد",
			description: "ابدأ طلبك الآن واختر مشروباتك المفضلة بسهولة.",
			icon: <BoltIcon sx={{ fontSize: 28 }} />,
			buttonLabel: "اطلب الآن",
			color: "primary",
			onClick: () => navigate("/clint/make-order"),
		},
		{
			title: "المنيو",
			description: "تصفح المنتجات والمشروبات المتاحة بشكل مرتب.",
			icon: <RestaurantMenuIcon sx={{ fontSize: 28 }} />,
			buttonLabel: "تصفح المنيو",
			color: "success",
			onClick: () => navigate("/clint/menu"),
		},
		{
			title: "سجل الطلبات",
			description: "راجع طلباتك السابقة وتفاصيل كل طلب بسرعة.",
			icon: <ReceiptLongIcon sx={{ fontSize: 28 }} />,
			buttonLabel: "الطلبات السابقة",
			color: "inherit",
			onClick: () => navigate("/clint/orders/history"),
		},
	];
   	useEffect(() => {
		document.title = 'Nuvvy - تجربة لا تُنسى';
	}, []);
	return (
		<Box dir="rtl" sx={{ maxWidth: 1100, mx: "auto", px: { xs: 1.5, md: 2 }, py: { xs: 2, md: 4 } }}>
			<Paper
				elevation={0}
				sx={{
					p: { xs: 2, md: 3 },
					borderRadius: 4,
					border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
					background: `linear-gradient(140deg, ${alpha(theme.palette.primary.main, 0.14)}, ${alpha(theme.palette.info.main, 0.08)})`,
				}}
			>
				<Stack
					direction={{ xs: "column", sm: "row" }}
					alignItems={{ xs: "center", sm: "center" }}
					spacing={1.5}
					sx={{
						mb: 2,
						pb: 1.5,
						borderBottom: `1px dashed ${alpha(theme.palette.primary.main, 0.35)}`,
					}}
				>
					<Box
						component="img"
						src={logo}
						alt="Nuvvy"
						sx={{
							width: { xs: 72, sm: 82 },
							height: { xs: 72, sm: 82 },
							objectFit: "contain",
							borderRadius: 2.5,
							p: 0.75,
							bgcolor: "common.white",
							boxShadow: `0 8px 22px ${alpha(theme.palette.common.black, 0.12)}`,
						}}
					/>
					<Box sx={{ textAlign: { xs: "center", sm: "right" } }}>
						<Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ fontWeight: 900, letterSpacing: 0.2 }}>
							Nuvvy
						</Typography>
						<Typography variant="body2" sx={{ fontWeight: 700, color: "text.primary" }}>
							Nuvvy. It’s a feeling.
						</Typography>
						<Typography variant="body2" color="text.secondary" sx={{ mt: 0.25, fontWeight: 700 }}>
							نوڤي. تجربة لا تُنسى.
						</Typography>
					</Box>
				</Stack>

				<Stack
					direction={{ xs: "column", md: "row" }}
					alignItems={{ xs: "flex-start", md: "center" }}
					justifyContent="space-between"
					spacing={2}
				>
					<Stack direction="row" spacing={1.5} alignItems="center" sx={{ width: "100%" }}>
						<Avatar
							sx={{
								width: { xs: 62, md: 72 },
								height: { xs: 62, md: 72 },
								bgcolor: "primary.main",
								fontWeight: 800,
								fontSize: { xs: 22, md: 26 },
							}}
						>
							{user?.name?.charAt(0) || "U"}
						</Avatar>
						<Box>
							<Typography variant={isMobile ? "h5" : "h4"} sx={{ fontWeight: 800, lineHeight: 1.1 }}>
								مرحباً، {user?.name || "ضيف"}
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
								رحلتك في Nuvvy تبدأ من هنا. اختر ما تريد  لبدأ تجربة فريدة معنا.
							</Typography>
						</Box>
					</Stack>

					
				</Stack>
			</Paper>

			<Grid container spacing={{ xs: 1.25, md: 2 }} sx={{ mt: 1.5 }}>
				{quickActions.map((action) => (
					<Grid item xs={12} md={4} key={action.title}>
						<Paper
							elevation={0}
							sx={{
								height: "100%",
								p: 2,
								borderRadius: 3,
								border: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
								boxShadow: `0 8px 24px ${alpha(theme.palette.common.black, 0.05)}`,
								display: "flex",
								flexDirection: "column",
								gap: 1.5,
								transition: "transform 0.2s ease, box-shadow 0.2s ease",
								"&:hover": {
									transform: isMobile ? "none" : "translateY(-5px)",
									boxShadow: isMobile ? undefined : `0 14px 30px ${alpha(theme.palette.common.black, 0.12)}`,
								},
							}}
						>
							<Box
								sx={{
									width: 44,
									height: 44,
									borderRadius: 2,
									display: "grid",
									placeItems: "center",
									bgcolor: alpha(theme.palette.primary.main, 0.1),
									color: "primary.main",
								}}
							>
								{action.icon}
							</Box>
							<Typography variant="h6" sx={{ fontWeight: 800 }}>
								{action.title}
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
								{action.description}
							</Typography>
							<Button
								variant={action.color === "inherit" ? "outlined" : "contained"}
								color={action.color === "inherit" ? undefined : action.color}
								onClick={action.onClick}
								endIcon={<ArrowForwardIcon />}
								fullWidth
								sx={{ borderRadius: 2, fontWeight: 700 }}
							>
								{action.buttonLabel}
							</Button>
						</Paper>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default ClintMainPage;
